<template>
  <div class="page" :style="themeStyle">
    <div v-if="!loaded" class="loading">Loading</div>
    <div v-if="loaded" class="root">

      <!-- SPLIT SCREEN HERO -->
      <div class="split">

        <!-- LEFT: Dark branded side -->
        <div class="split-left">
          <div class="sl-inner">
            <img v-if="loinfo && loinfo.main_logo" :src="loinfo.main_logo" class="logo" />

    
            <h1 class="sl-headline" v-html="heroH1Html"></h1>
            <p class="sl-body">{{ heroBody }}</p>

            <div class="sl-btns">
      
              <a v-if="applyLeftLink" class="sl-ghost" :href="applyLeftLink">{{ heroSecondaryText }}</a>
            </div>

            <div class="sl-quick">
              <a v-if="loinfo && loinfo.phone_number" class="sl-ql" :href="'tel:' + loinfo.phone_number">Call</a>
              <span class="sl-dot">·</span>
              <a v-if="loinfo && loinfo.email" class="sl-ql" :href="'mailto:' + loinfo.email">Email</a>
              <span class="sl-dot">·</span>
              <a v-if="realtor && realtor.website_url" class="sl-ql" :href="realtor.website_url" target="_blank" rel="noreferrer">Partner</a>
            </div>
          </div>
          <!-- Diagonal cut overlay -->
          <div class="diagonal-cut"></div>
        </div>

        <!-- RIGHT: Light side -->
        <div class="split-right">
          <div class="sr-inner">
            <div class="sr-badge">{{ loName || "Loan Officer" }} & {{ realtorName || "Realtor" }}</div>

            <!-- LO Card -->
            <div class="pcard">
              <div class="pcard-accent-bar"></div>
              <div class="pcard-row">
                <img v-if="loinfo && loinfo.lo_image" :src="loinfo.lo_image" class="pcard-img" />
                <div class="pcard-text">
                  <div class="pcard-role-tag">Loan Officer</div>
                  <div class="pcard-name">{{ loName }}</div>
                  <div class="pcard-sub">{{ loTitle }}</div>
                  <div v-if="loinfo && loinfo.nmls" class="pcard-nmls">NMLS {{ (loinfo.nmls || "").trim() }}</div>
                </div>
              </div>
              <div class="pcard-contacts">
                <a v-if="loinfo && loinfo.phone_number" :href="'tel:' + loinfo.phone_number" class="pcard-chip">{{ loinfo.phone_number }}</a>
                <a v-if="loinfo && loinfo.email" :href="'mailto:' + loinfo.email" class="pcard-chip">{{ loinfo.email }}</a>
              </div>
              <a class="pcard-apply" :href="applyRightLink">{{ heroPrimaryText }}</a>
            </div>

            <!-- Realtor Card -->
            <div class="pcard re-pcard">
              <div class="pcard-accent-bar re-bar"></div>
              <div class="pcard-row">
                <img v-if="realtor && realtor.headshot_url" :src="realtor.headshot_url" class="pcard-img" />
                <div class="pcard-text">
                  <div class="pcard-role-tag re-tag">{{ realtor?.partner_title || 'Partner' }}</div>
                  <div class="pcard-name">{{ realtorName }}</div>
                  <div class="pcard-sub">{{ realtor && realtor.brokerage_name ? realtor.brokerage_name : "" }}</div>
                  <div v-if="realtor && realtor.nmls" class="pcard-nmls">NMLS {{ (realtor.nmls || "").trim() }}</div>
                </div>
              </div>
              <div class="pcard-contacts">
                <a v-if="realtor && realtor.phone_number" :href="'tel:' + realtor.phone_number" class="pcard-chip re-chip">{{ realtor.phone_number }}</a>
                <a v-if="realtor && realtor.email" :href="'mailto:' + realtor.email" class="pcard-chip re-chip">{{ realtor.email }}</a>
                <a v-if="realtor && realtor.website_url" :href="realtor.website_url" class="pcard-chip re-chip" target="_blank" rel="noreferrer">Website</a>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Bottom accent strip -->
      <div class="bottom-strip">
        <div class="bs-left">
          <span class="bs-tag">CO-BRANDED PARTNERSHIP</span>
        </div>
        <div class="bs-right">
      
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import coBrandMixin from "../../mixins/coBrandMixin.js";
const BRAND_COLORS = {
  zonalending: { primary: "#eb610a", accent: "#646363" },
  radiantmortgage: { primary: "#1C1F39", accent: "#DB9457" },
  conradmortgage: { primary: "#4a4b4b", accent: "#d4af37" },
  theimgteam: { primary: "#ff6633", accent: "#4a4c54" },
  responsivemortgage: { primary: "#07212c", accent: "#FF7F47" },
  kpmortgage: { primary: "#0D2821", accent: "#34BFC6" },
  ignitemortgage: { primary: "#000000", accent: "#00b1eb" },
  goldstarfinancial: { primary: "#0b1726", accent: "#c69c39" },
};
function getBrandKey(email) {
  if (!email) return null;
  const d = email.slice(email.indexOf("@") + 1).toLowerCase();
  return d.split(".")[0] || null;
}
export default {
  name: "CoBrandSplit",
  mixins: [coBrandMixin],
  computed: {
    brandKey() { const k = getBrandKey(this.loinfo?.email); return (k && BRAND_COLORS[k]) ? k : "goldstarfinancial"; },
    palette() { return BRAND_COLORS[this.brandKey] || BRAND_COLORS.goldstarfinancial; },
    themeStyle() { return { "--p": this.palette.primary, "--a": this.palette.accent }; },
    
    heroH1Html() {
      const h = (this.realtor?.header1 || this.loinfo?.header1 || "").trim();
      if (!h) return "Ready to get<br/><em>started?</em>";
      const parts = h.split(",");
      if (parts.length > 1) {
        const a = parts[0].trim();
        const b = parts.slice(1).join(",").trim();
        return `${a}<br/><em>${b}</em>`;
      }
      return h;
    },
    
    heroHeading() { return this.loinfo?.text_section_heading || "About"; },
    heroPrimaryText() { return this.loinfo?.right_button_text || "Apply Now"; },
    heroSecondaryText() { return this.loinfo?.left_button_text || "Schedule Appointment"; },
    heroBody() {
      const m = (this.realtor?.main || this.loinfo?.main || "").trim();
      if (m) return m;
      return [this.loinfo?.text_section_body_p1, this.loinfo?.text_section_body_p2].filter(Boolean).join(" ").trim()
        || this.loinfo?.footer_slogan || "Start your application in minutes and we'll guide you from application through closing.";
    },
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;600;800;900&family=Fraunces:ital,wght@0,200;0,700;1,200;1,700&display=swap');

.page {
  min-height: 100vh;
  font-family: 'Manrope', sans-serif;
  --p: #0b1726;
  --a: #c69c39;
  --a-on-dark: color-mix(in srgb, var(--a) 90%, white);
  --p-border: color-mix(in srgb, var(--p) 12%, transparent);
  background: #f9f8f6;
  display: flex;
  flex-direction: column;
}

.root { display: flex; flex-direction: column; min-height: 100vh; }

/* SPLIT */
.split { display: grid; grid-template-columns: 46% 54%; flex: 1; min-height: calc(100vh - 56px); position: relative; }

/* LEFT SIDE */
.split-left {
  background: var(--p);
  position: relative;
  overflow: hidden;
}
.split-left::after {
  content: "";
  position: absolute; top: 0; right: -1px; bottom: 0;
  width: 80px;
  background: #f9f8f6;
  clip-path: polygon(100% 0, 100% 100%, 0 100%);
  z-index: 2;
}
/* accent circle decor */
.split-left::before {
  content: "";
  position: absolute; top: -140px; right: -140px;
  width: 400px; height: 400px; border-radius: 999px;
  background: radial-gradient(circle, color-mix(in srgb, var(--a) 35%, transparent), transparent 60%);
  pointer-events: none;
}

.sl-inner { padding: 48px 80px 48px 48px; position: relative; z-index: 1; height: 100%; display: flex; flex-direction: column; justify-content: center; }
.logo {  margin-bottom: 36px; }
.logo { width: 160px; max-height:80px; object-fit: contain;  filter: brightness(0) invert(1); opacity: 0.9; } 
.sl-tag { font-size: 11px; font-weight: 600; letter-spacing: 0.22em; text-transform: uppercase; color: var(--a); margin-bottom: 12px; }
.sl-headline {
  font-family: 'Fraunces', serif;
  font-size: clamp(36px, 5vw, 60px);
  font-weight: 700; line-height: 1.1;
  color: #fff; margin: 0 0 16px;
}
.hl-accent { color: var(--a); font-style: italic; font-weight: 200; }
.sl-body { font-size: 14px; line-height: 1.75; color: rgba(255,255,255,0.55);  margin-bottom: 28px; }
.sl-btns { display: flex; gap: 10px; flex-wrap: wrap; margin-bottom: 24px; justify-content: center;}
.sl-cta {
  background: var(--a); color: var(--p);
  font-size: 13px; font-weight: 800; text-decoration: none;
  padding: 12px 22px; border-radius: 8px;
  transition: opacity 0.2s;
  width:55%
}
.sl-cta:hover { opacity: 0.88; }
.sl-ghost {
  background: rgba(255,255,255,0.08); color: rgba(255,255,255,0.75);
  border: 1px solid rgba(255,255,255,0.18);
  font-size: 13px; font-weight: 600; text-decoration: none;
  padding: 12px 22px; border-radius: 8px; transition: background 0.2s;
}
.sl-ghost:hover { background: rgba(255,255,255,0.14); }
.sl-quick { display: flex; align-items: center; gap: 8px; }
.sl-ql { font-size: 12px; text-decoration: none; color: rgba(255,255,255,0.45); transition: color 0.2s; }
.sl-ql:hover { color: var(--a); }
.sl-dot { color: rgba(255,255,255,0.2); }

/* RIGHT SIDE */
.split-right { background: #f9f8f6; padding: 0; overflow-y: auto; }
.sr-inner { padding: 48px 40px 48px 60px; display: flex; flex-direction: column; justify-content: center; min-height: 100%; gap: 16px; }
.sr-badge {
  font-size: 11px; font-weight: 600; letter-spacing: 0.18em; text-transform: uppercase;
  color: color-mix(in srgb, var(--p) 40%, transparent); margin-bottom: 4px;
}

/* PROFILE CARDS */
.pcard {
  background: #fff; border-radius: 18px;
  border: 1px solid rgba(0,0,0,0.07);
  padding: 18px; overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);
  position: relative;
  transition: box-shadow 0.2s;
}
.pcard:hover { box-shadow: 0 8px 30px rgba(0,0,0,0.10); }

.pcard-accent-bar {
  position: absolute; top: 0; left: 0; right: 0; height: 3px;
  background: linear-gradient(90deg, var(--p), color-mix(in srgb, var(--p) 50%, var(--a)));
}
.re-bar { background: linear-gradient(90deg, var(--a), color-mix(in srgb, var(--a) 50%, var(--p))); }

.pcard-row { display: flex; gap: 14px; align-items: flex-start; margin: 12px 0; }
.pcard-img { width: 62px;  border-radius: 12px; object-fit: cover; flex-shrink: 0; }
.pcard-role-tag { font-size: 10px; font-weight: 700; letter-spacing: 0.18em; text-transform: uppercase; color: var(--p); margin-bottom: 4px; }
.re-tag { color: var(--a); }
.pcard-name { font-size: 17px; font-weight: 800; color: var(--p); line-height: 1.2; }
.pcard-sub { font-size: 12px; color: #888; margin-top: 2px; }
.pcard-nmls { font-size: 11px; color: #aaa; margin-top: 1px; }
.pcard-contacts { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 12px; }
.pcard-chip {
  font-size: 11px; font-weight: 500; text-decoration: none;
  background: color-mix(in srgb, var(--p) 6%, transparent);
  color: var(--p); padding: 5px 12px; border-radius: 50px;
  border: 1px solid color-mix(in srgb, var(--p) 12%, transparent);
  transition: background 0.2s;
}
.pcard-chip:hover { background: color-mix(in srgb, var(--p) 12%, transparent); }
.re-chip { color: color-mix(in srgb, var(--a) 85%, black); background: color-mix(in srgb, var(--a) 8%, transparent); border-color: color-mix(in srgb, var(--a) 20%, transparent); }
.re-chip:hover { background: color-mix(in srgb, var(--a) 15%, transparent); }
.pcard-apply {
  display: block; width: 100%; text-align: center; text-decoration: none;
  background: var(--p); color: #fff;
  font-size: 13px; font-weight: 700; padding: 11px;
  border-radius: 10px; transition: opacity 0.2s;
}
.pcard-apply:hover { opacity: 0.88; }

/* BOTTOM STRIP */
.bottom-strip {
  height: 56px; background: var(--a);
  display: flex; align-items: center; justify-content: space-between;
  padding: 0 40px;
}
.bs-tag { font-size: 11px; font-weight: 700; letter-spacing: 0.22em; text-transform: uppercase; color: var(--p); }
.bs-link { font-size: 13px; font-weight: 800; text-decoration: none; color: var(--p); }
.bs-link:hover { text-decoration: underline; }

@media (max-width: 780px) {
  .split { grid-template-columns: 1fr; }
  .split-left::after { display: none; }
  .sr-inner { padding: 32px 24px; }
  .sl-inner { padding: 36px 24px; }
}
</style>
